import { ICheckboxFormControlOptions } from "../checkbox-form-control";
import { _SSControlOptionsBase } from "./types/_ss-control-options-base";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";

export class SSCheckboxOptions implements _SSControlOptionsBase<'checkbox'> {

  constructor(
    private _initialOptions?: ICheckboxFormControlOptions
  ) {

    this._initOptions();
  }

  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'checkbox'>(this, this._initialOptions);

  }

  dispose() {

  }
}
